<template>
	<section class="sk-navigation" >
		<header class="sk-navigation__header">
			<!-- <navigation-user-account />
			<locale-flag-selector /> -->
			<profile-user-account>
				<div class="sk-nav-link-simple">
					<navigation-link-text route="UserProfileAccount" routeStartsWith="UserProfile" :title="$t('base.general.user_account')" />
					<navigation-link-text route="AuthLogout" :title="$t('base.auth.logout')" />
				</div>
				<!-- <change-account /> -->
				<!-- <locale-flag-selector /> -->
			</profile-user-account>
		</header>
		<main class="sk-navigation__sub-content">
			<navigation-button-icon @click="onChangeAccount_ClickHandler" icon="buttons/shuffle.svg" title="Change account" />
			<navigation-link-icon route="UserProfileAccount" routeStartsWith="UserProfile" icon="buttons/settings.svg" title="Account Configurations" />
			<navigation-link-icon route="AlertList" routeStartsWith="Alert" icon="buttons/flash.svg" title="Alerts" :count="getAlertsNewCount" />
		</main>
		<main class="sk-navigation__content">
			<navigation-link route="Dashboard" :title="$t('base.general.dashboard')" icon="buttons/dashboard.svg" />
			<navigation-link route="DevicesList" routeStartsWith="Devices" :title="$t('base.general.devices')" icon="buttons/smartwatch.svg" />
			<navigation-link route="WatchList" routeStartsWith="Watch" :title="$t('base.general.patients')" icon="buttons/patient.svg" />
			<!-- <navigation-link route="AlertList" :title="$t('base.general.alerts')" icon="buttons/dashboard.svg" /> -->
			<!-- <navigation-link route="UserProfileAccount" :title="$t('base.general.user_account')" icon="" /> -->
		</main>
		<footer class="sk-navigation__footer"></footer>
	</section>
</template>

<script>
/*
import NavigationDashboard from './NavigationDashboard'
import NavigationPatients from './NavigationPatients'
import NavigationDevices from './NavigationDevices'
import NavigationAlerts from './NavigationAlerts'
import NavigationAccount from './NavigationAccount'
*/
import NavigationLink from './NavigationLink'
import NavigationLinkText from './NavigationLinkText'
import NavigationLinkIcon from './NavigationLinkIcon'
import NavigationButtonIcon from './NavigationButtonIcon'
import LocaleFlagSelector from '@/components/i18n/LocaleFlagSelector'
import StaticContentLinks from '@/components/statics/StaticContentLinks'
import NavigationUserAccount from './account/UserAccount'
import ProfileUserAccount from './account/ProfileUserAccount'
import ChangeAccount from '@/components/navigation/account/ChangeAccount'
import { mapGetters } from 'vuex'
export default {
	components: {
		NavigationLink,
		NavigationLinkText,
		NavigationLinkIcon,
		NavigationButtonIcon,
		LocaleFlagSelector,
		StaticContentLinks,
		NavigationUserAccount,
		ProfileUserAccount,
		ChangeAccount
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			ticking: false
		}
	},
	computed: {
		user () {
			return this.$store.getters.getUser
		},
		alerts () {
			return this.$store.getters.getAlerts.filter(alert => alert.type === 1 && !alert.reading_time)
		},
		watches () {
			return this.$store.getters.getWatches
		},
		isAdmin () {
			return this.$store.getters.isAdmin
		},
		matchAccount () {
			return this.$route.path.match(/\/user\/account*/)
		},
		matchAdmin () {
			return this.$route.path.match(/\/admin\/*/)
		},
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		getAlertsNewCount() {
			return this.getAlertsNew(this.currentUser).length
		},
		...mapGetters({
			getAlertsNew: 'WARNINGS_UNREAD',
			currentUser: 'CURRENT_USER'
		})
	},
	methods: {
		getAll () {
			// if (this.user) {
			// 	debugger
			// 	this.$store.dispatch('getPlan', { context: this, user_uid: this.user.uid })
			// 	this.$store.dispatch('getAccounts', { context: this, user_uid: this.user.uid })
			// 	this.$store.dispatch('getPermissions', { context: this, user_uid: this.user.uid })
			// }
		},
		onWatchprofileUpdated (payload) {
			this.getAll()
		},
		matchWatchUser (user_uid, watch_id) {
			return this.$route.path.match(new RegExp(`\/users\/${user_uid}\/watches\/${watch_id}`))
		},
		onChangeAccount_ClickHandler() {
			this.$root.$emit('change-account', {})
		}
	},
	mounted () {
		this.$root.$on('watch-profile-updated', this.onWatchprofileUpdated)
		this.getAll()
	},
	updated () {
		if (this.$refs.watches) {
			this.updateDropdown(this.$refs.watches)
		}
	},
	beforeDestroy () {
		this.$root.$off('watch-profile-updated', this.onWatchprofileUpdated)
	}
}
</script>

<style scoped>

.sk-navigation {
	display: grid;
	height: 100%;
	grid-template-rows: auto auto 1fr;
}

.sk-navigation__header {
	display: grid;
	align-items: flex-start;
	justify-items: center;
	padding: 0;
}

.sk-navigation__sub-content {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 5px 0;
	border-bottom: rgba(0, 0, 0, 0.1) solid 1px;
}
.sk-navigation__content {
	overflow-y: auto;
	max-height: calc(100vh - 64px - 175px - 75px);
}

</style>



// WEBPACK FOOTER //
// src/components/navigation/Navigation.vue